import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/bonuses';
export function Bonuses() {
  return <section aria-label="Bonos" className="border-y border-white/5 bg-ink-2" data-id="element-14" data-mp="plsj010puu7n">
      <div className="mx-auto max-w-5xl px-5 pb-7" data-id="element-15" data-mp="autfv5ingxvg">
        <h2 className="pt-8 text-center font-display text-2xl font-black text-white sm:text-4xl" data-id="element-16" data-mp="ftmwh6t8h4zu">
          🎁 5 Bonos estratégicos — siempre incluidos
        </h2>

        <div className="mt-12 grid gap-5 sm:grid-cols-2" data-id="element-17" data-mp="1wriczy4kncx">
          {bonuses.map((b, i) => <motion.div key={b.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i % 2 * 0.08
        }} className="relative flex flex-col rounded-2xl border border-bordo-soft/40 bg-ink p-6" data-id="element-18" data-mp="5tnll39cd2jt" data-mpi={i}>
              <div className="mb-3 flex flex-wrap items-center justify-between gap-2" data-id="element-19" data-mp="1r8juv7bb56jv">
                <span className="inline-flex items-center gap-1.5 rounded-full bg-bordo/30 px-3 py-1 text-xs font-bold text-plata-soft" data-id="element-20" data-mp="3icvejinyew53">
                  <GiftIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-21" data-mp="3r6qi4m9fgeim" /> Bono {b.n}
                </span>
                <span className="text-sm font-bold" data-id="element-22" data-mp="3n5erqeiqbp9d">
                  <span className="text-white/40 line-through" data-id="element-23" data-mp="3n5oi437oryfl">{b.price}</span>{' '}
                  <span className="text-bordo-light" data-id="element-24" data-mp="2zgdco8fe5fv4">GRATIS</span>
                </span>
              </div>
              <h3 className="text-base font-bold text-white" data-id="element-25" data-mp="2ui23lzwx79dy">{b.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-white/60" data-id="element-26" data-mp="38gijagcrga88">{b.desc}</p>
            </motion.div>)}
        </div>

        <div className="mt-10 rounded-2xl border border-plata/30 bg-white/5 p-6 text-center" data-id="element-27" data-mp="33fujp6agul2e">
          <p className="text-base font-bold text-white sm:text-lg" data-id="element-28" data-mp="noggn9jmbjuk">
            💰 Valor total de los bonos:{' '}
            <span className="text-white/50 line-through" data-id="element-29" data-mp="it15wqgwq42d">$46.500 ARS</span>{' '}
            <span className="text-[15px] text-bordo-light" data-id="element-30" data-mp="3ciekt08n1oxi">HOY GRATIS CON TU PACK</span>
          </p>
        </div>
      </div>
    </section>;
}